import { priceRuleService } from '../../services/priceRuleService';
import store from '../store/store';

export const PRICE_RULES_REQUEST = 'PRICE_RULES_REQUEST';
export const PRICE_RULES_SUCCESS = 'PRICE_RULES_SUCCESS';
export const PRICE_RULES_FAILURE = 'PRICE_RULES_FAILURE';

export const ADD_PRICE_RULE_REQUEST = 'ADD_PRICE_RULE_REQUEST';
export const ADD_PRICE_RULE_SUCCESS = 'ADD_PRICE_RULE_SUCCESS';
export const ADD_PRICE_RULE_FAILURE = 'ADD_PRICE_RULE_FAILURE';

export const DELETE_PRICE_RULE_REQUEST = 'DELETE_PRICE_RULE_REQUEST';
export const DELETE_PRICE_RULE_SUCCESS = 'DELETE_PRICE_RULE_SUCCESS';
export const DELETE_PRICE_RULE_FAILURE = 'DELETE_PRICE_RULE_FAILURE';

export const UPDATE_PRICE_RULE_REQUEST = 'UPDATE_PRICE_RULE_REQUEST';
export const UPDATE_PRICE_RULE_SUCCESS = 'UPDATE_PRICE_RULE_SUCCESS';
export const UPDATE_PRICE_RULE_FAILURE = 'UPDATE_PRICE_RULE_FAILURE';

export const ASSIGN_PRICE_RULE_TO_CATEGORIES_REQUEST = 'ASSIGN_PRICE_RULE_TO_CATEGORIES_REQUEST';
export const ASSIGN_PRICE_RULE_TO_CATEGORIES_SUCCESS = 'ASSIGN_PRICE_RULE_TO_CATEGORIES_SUCCESS';
export const ASSIGN_PRICE_RULE_TO_CATEGORIES_FAILURE = 'ASSIGN_PRICE_RULE_TO_CATEGORIES_FAILURE';

export const GET_CATEGORIES_BY_PRICERULE_REQUEST = 'GET_CATEGORIES_BY_PRICERULE_REQUEST';
export const GET_CATEGORIES_BY_PRICERULE_SUCCESS = 'GET_CATEGORIES_BY_PRICERULE_SUCCESS';
export const GET_CATEGORIES_BY_PRICERULE_FAILURE = 'GET_CATEGORIES_BY_PRICERULE_FAILURE';

// Fiyat kurallarını getir
export const getPriceRules = (page = 1, searchTerm = '') => async (dispatch) => {
    dispatch({ type: PRICE_RULES_REQUEST });
    try {
        const response = await priceRuleService.getPriceRules(page, searchTerm);
        dispatch({ type: PRICE_RULES_SUCCESS, payload: response.data.data });
    } catch (error) {
        dispatch({ type: PRICE_RULES_FAILURE, payload: error.message });
    }
};

// Yeni fiyat kuralı ekle
export const addPriceRule = (priceRule) => async (dispatch) => {
    dispatch({ type: ADD_PRICE_RULE_REQUEST });
    try {
        const response = await priceRuleService.addPriceRule(priceRule);
        dispatch({ type: ADD_PRICE_RULE_SUCCESS, payload: response.data.data });
    } catch (error) {
        dispatch({ type: ADD_PRICE_RULE_FAILURE, payload: error.message });
    }
};

// Fiyat kuralını sil
export const deletePriceRule = (id) => async (dispatch) => {
    dispatch({ type: DELETE_PRICE_RULE_REQUEST });
    try {
        await priceRuleService.deletePriceRule(id);
        dispatch({ type: DELETE_PRICE_RULE_SUCCESS, payload: id });
    } catch (error) {
        dispatch({ type: DELETE_PRICE_RULE_FAILURE, payload: error.message });
    }
};

// Fiyat kuralını güncelle
export const updatePriceRule = (id, priceRule) => async (dispatch) => {
    dispatch({ type: UPDATE_PRICE_RULE_REQUEST });
    try {
        const response = await priceRuleService.updatePriceRule(id, priceRule);
        dispatch({ type: UPDATE_PRICE_RULE_SUCCESS, payload: response.data });
    } catch (error) {
        dispatch({ type: UPDATE_PRICE_RULE_FAILURE, payload: error.message });
    }
};

// Kategoriye fiyat kuralı ata (toplu)
export const assignPriceRuleToCategories = (priceRuleId, categoryIds) => async (dispatch) => {
    dispatch({ type: ASSIGN_PRICE_RULE_TO_CATEGORIES_REQUEST });
    try {
        await priceRuleService.assignPriceRuleToCategories(priceRuleId, categoryIds);
        dispatch({ type: ASSIGN_PRICE_RULE_TO_CATEGORIES_SUCCESS });
    } catch (error) {
        dispatch({ type: ASSIGN_PRICE_RULE_TO_CATEGORIES_FAILURE, payload: error.message });
    }
};

// Bir kurala bağlı kategorileri getir
export const getCategoriesByPriceRule = (priceRuleId, page = 1, searchTerm = '') => async (dispatch) => {
    dispatch({ type: GET_CATEGORIES_BY_PRICERULE_REQUEST });
    try {
        const userToken = store.getState()?.auth?.user?.accessToken?.token;
        const response = await fetch(`${import.meta.env.VITE_API_URL}/PriceRule?Id=${priceRuleId}&WithCategory=true`, {
            headers: {
                Authorization: `Bearer ${userToken}`
            }
        });
        const data = await response.json();
        const categories = Array.isArray(data.data?.data) && data.data.data.length > 0 ? data.data.data[0].categories : [];
        dispatch({ type: GET_CATEGORIES_BY_PRICERULE_SUCCESS, payload: categories });
    } catch (error) {
        dispatch({ type: GET_CATEGORIES_BY_PRICERULE_FAILURE, payload: error.message });
    }
};

// Tekil kategoriden fiyat kuralı kaldır (priceRuleId=null)
export const removePriceRuleFromCategory = (categoryId, priceRuleId) => async (dispatch, getState) => {
    try {
        const state = getState();
        const category = state.priceRule.categoriesByRule.find(cat => cat.id === categoryId);
        if (!category) {
            throw new Error('Kategori bulunamadı');
        }
        const payload = {
            id: category.id,
            userId: category.userId,
            name: category.name,
            vatRate: category.vatRate,
            priceRuleId: null,
            createDate: category.createDate,
            updateDate: category.updateDate,
            ia: category.ia
        };
        await priceRuleService.removePriceRuleFromCategory(payload);
        // Silme sonrası kategorileri güncelle
        dispatch(getCategoriesByPriceRule(priceRuleId, 1, ''));
    } catch (error) {
        // Hata durumunda toast ile gösterilecek, burada error handling yapılabilir
    }
}; 